import styled from 'styled-components';
import { NavigationActionButton } from '../navigation-action-button/NavigationActionButton';

export const MethodSelectOptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  padding: 2rem;
  ${({ theme }) => theme.media.tablet`
     padding: 2rem 3.6rem;
  `};
`;

export const InstantActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1.6rem;
  margin-bottom: 2.4rem;
  gap: 1.2rem;
`;

export const CustomNavigationActionButton = styled(NavigationActionButton)`
  margin-top: 1.2rem;
  background: linear-gradient(180deg, #eff4ff 0%, #dde8ff 100%);
`;
